<template>
  <div>
    <el-table :data="ybordersData" :height="wheight-500"  v-loading="loading">
      <el-table-column prop="order_id" label="订单号" width="170"></el-table-column>
      <el-table-column prop="bn" label="商品货号" width="100"></el-table-column>
      <el-table-column prop="name" label="商品名称" width="130"></el-table-column>
      <el-table-column prop="nums" label="数量" width="50"></el-table-column>
      <el-table-column prop="price" label="实际销售单价" width="130"></el-table-column>
      <el-table-column prop="amount" label="总金额" width="80"></el-table-column>
      <el-table-column prop="total_commission" label="佣金" width="80"></el-table-column>
      <el-table-column prop="order_status" label="订单状态" width="130">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.order_status=='100'">已支付</el-tag>
          <el-tag v-else-if="scope.row.order_status=='105'" type="danger">退款中</el-tag>
          <el-tag v-else-if="scope.row.order_status=='110'" type="info">已退款</el-tag>
          <el-tag v-else-if="scope.row.order_status=='120'" type="warning">已支付已发货</el-tag>
          <el-tag v-else-if="scope.row.order_status=='130'" type="danger">已支付已退货</el-tag>
          <el-tag v-else-if="scope.row.order_status=='140'" type="info">已退货已退款</el-tag>
          <el-tag v-else-if="scope.row.order_status=='150'" type="success">已成交</el-tag>
          <el-tag v-else-if="scope.row.order_status=='160'" type="info">已作废</el-tag>
          <el-tag v-else-if="scope.row.order_status=='170'" type="info">已分佣</el-tag>
          <el-tag v-else-if="scope.row.order_status=='180'" type="info">分佣已停止</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="billing_status" label="结算状态" width="130">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.billing_status=='1'">已结算</el-tag>
          <el-tag v-else-if="scope.row.billing_status=='2'" type="info">结算失败</el-tag>
          <el-tag v-else type="danger">未结算</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="member_id" label="B2C会员ID" width="130"></el-table-column>
      <el-table-column prop="user_id" label="怡贝会员ID" width="130"></el-table-column>
      <el-table-column prop="store_name" label="店铺名称" width="160"></el-table-column>
      <el-table-column prop="number" label="英克ID" width="100"></el-table-column>
      <el-table-column prop="send_type" label="配送类型" width="100"></el-table-column>
      <el-table-column prop="yb_createtime_date" label="下单时间" width="170"></el-table-column>
    </el-table>
    <div v-if="total_count > pageSize" class="content-padded tc">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :total='total_count' :page-size="pageSize">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getYbordersList } from '../../../api/sharer'
import {mapGetters} from "vuex";
export default {
  props: ['userId', 'isLoad'],
  data () {
    return {
      loading: false,
      params: {},
      total_count: 0,
      currentPage: 1,
      pageSize: 20,
      ybordersData: []
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    handleCurrentChange (val) {
      this.currentPage = val
      this.loading = false
      this.getParams()
      this.getItems(this.params)
    },
    getParams () {
      this.params.page = this.currentPage
      this.params.pageSize = this.pageSize
    },
    getItems (filter) {
      console.log(filter)
      this.loading = true
      getYbordersList(filter).then(response => {
        this.ybordersData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
      })
    },
  },
  mounted () {
    // this.params = {page: this.currentPage, pageSize: this.pageSize, user_id: this.userId}
    // this.getItems(this.params)
  },
  watch: {
    userId (newVal, oldVal) {
      if (this.isLoad) {
        this.params = {page: this.currentPage, pageSize: this.pageSize, user_id: newVal}
        this.getItems(this.params)
      }
    },
    isLoad (newVal, oldVal) {
      if (newVal) {
        this.params = {page: this.currentPage, pageSize: this.pageSize, user_id: this.userId}
        this.getItems(this.params)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 10px;
  .frm-tips {
    color: #8d8d8d;
  }
}
</style>



// WEBPACK FOOTER //
// orderlist.vue?4bdb84c6